import {z} from 'zod'

export type Time = `${number}${number}:${number}${number}`
export const Time = z.iso.time() as z.ZodType<Time>
